import {none, option, Option} from "ts-option";
import {CreateUpdateJobAppointmentApiDto, JobAppointmentApiDto} from "../../../api/model/rest";
import AppointmentStatus, {AppointmentStatusEnum} from "../AppointmentStatus";
import AppointmentType from "../AppointmentType";
import {getJobAppointmentType} from "../../../store/view/appointment";
import JsonConverter from "../../../api/helper/JsonConverter";
import JobAppointmentType from "./JobAppointmentType";
import moment = require("moment");

const uuidv4 = require("uuid/v4");

export default class JobAppointment {

	constructor(public readonly id: string,
		public readonly dateTime: moment.Moment,
		public readonly endDateTime: moment.Moment,
		public readonly duration: number,
		public readonly status: AppointmentStatus,
		public readonly typeId: Option<string>,
		public readonly type: Option<JobAppointmentType>,
		public readonly jobId: Option<string>,
		public readonly assignees: string[],
		public readonly referenceNumber: Option<string>) {}

	static fromJson(json: JobAppointmentApiDto): JobAppointment {
		const typeId = option(json.typeId);
		const type = typeId.isDefined ? getJobAppointmentType(json.typeId) : none;
		const startDateTime = moment(json.dateTime);
		const endDateTime = moment(json.endDateTime);
		const duration = moment(endDateTime).diff(moment(startDateTime), "minutes");
		return new JobAppointment(json.id, startDateTime, endDateTime, duration, AppointmentStatus.fromString(json.status),
			typeId, type, option(json.jobId), json.assignees, option(json.referenceNumber))
	}

	getDate(): moment.Moment {
		return moment(this.dateTime).startOf("day");
	}

	toJson() {
		const json: CreateUpdateJobAppointmentApiDto = {
			dateTime: this.dateTime.format(),
			endDateTime: this.endDateTime.format(),
			status: this.status.value,
			typeId: this.typeId.orNull,
			assignees: this.assignees
		};
		return JsonConverter.removeEmptyFields(json);
	}

	copy({dateTime = this.dateTime, status = this.status, type = this.type, assignees = this.assignees, duration = this.duration}) {
		const endDateTime = moment(dateTime).add(duration, "minutes");
		return new JobAppointment(this.id, dateTime, endDateTime, duration, status, type.map(t => t.id), type, this.jobId,
			assignees, this.referenceNumber)
	}

	static create(dateTime: moment.Moment, type: Option<AppointmentType>, assigness: string[], duration: number) {
		const endDateTime = moment(dateTime).add(duration, "minutes");
		return new JobAppointment(uuidv4(), dateTime, endDateTime, duration,
			AppointmentStatus.fromString(AppointmentStatusEnum.Unconfirmed),
			type.map(t => t.id), type, none, assigness, none);
	}

	public static compare(a: JobAppointment, b: JobAppointment) {
		return a.dateTime.diff(b.dateTime);
	}
}